var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTruck = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "currentColor",
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.55 6C4.1422 6 3 7.1758 3 8.625v17.5c0 1.4492 1.1422 2.625 2.55 2.625h.85c0 2.8984 2.2844 5.25 5.1 5.25s5.1-2.3516 5.1-5.25h6.8c0 2.8984 2.2844 5.25 5.1 5.25s5.1-2.3516 5.1-5.25h1.7c.9403 0 1.7-.782 1.7-1.75s-.7597-1.75-1.7-1.75v-6.2727c0-.9296-.3559-1.8211-.9934-2.4773L30.2 12.2727c-.6375-.6563-1.5034-1.0227-2.4066-1.0227H25.1V8.625C25.1 7.1758 23.9578 6 22.55 6zm19.55 8.75h2.6934L31.9 18.9773V20h-6.8zm-16.15 14c0-.6962.2687-1.3639.7469-1.8562.4782-.4922 1.1268-.7688 1.8031-.7688s1.3249.2766 1.8031.7688.7469 1.16.7469 1.8562-.2687 1.3639-.7469 1.8562c-.4782.4922-1.1268.7688-1.8031.7688s-1.3249-.2766-1.8031-.7688-.7469-1.16-.7469-1.8562m19.55-2.625c.6763 0 1.3249.2766 1.8031.7688s.7469 1.16.7469 1.8562-.2687 1.3639-.7469 1.8562c-.4782.4922-1.1268.7688-1.8031.7688s-1.3249-.2766-1.8031-.7688-.7469-1.16-.7469-1.8562.2687-1.3639.7469-1.8562c.4782-.4922 1.1268-.7688 1.8031-.7688"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTruck);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/truck.a7b95f1c40f65cf323b75d0250310898.svg";